import './ItemChat.css'
import {defaultAvatarUrl} from '@utils/Const'
import {Image} from '@chakra-ui/react'
const ItemChatImage = ({avatar, text, url}: any) => {
  return (
    <div className={`chat-message`}>
      <img src={defaultAvatarUrl} alt="Avatar" className="avatar" />
      <div className="message-bot">
        <Image
          maxH={400}
          maxW={600}
          src={url}
          alt="Image"
          className="image"
          objectFit="contain"
          borderRadius="lg"
        />
      </div>
    </div>
  )
}

export default ItemChatImage
